import { ajaxHandler, toast } from "./utilities/utilities";

/**
 * Manage account & billing information form submission
 */
document.addEventListener('DOMContentLoaded', function () {
    const btnEmailChange = document.getElementById('btn-change-email')
    const personalSettingForm = document.getElementById('personal-setting-form');
    const billingSettingForm = document.getElementById('billing-setting-form');
    const spinnerElem = `<span class="platform-spinner-border platform-spinner-border-sm" aria-hidden="true"></span>`;

    if (personalSettingForm) {
        personalSettingForm.onsubmit = async (e) => {
            e.preventDefault();
            const formData = new FormData(personalSettingForm);
            const submitBtn = document.querySelector('button[update-personal-info]');

            const newPass = formData.get('new_password');
            const confirmPass = formData.get('confirm_password');

            // If new pass & confirm pass not empty then check both are same or not
            if (newPass && confirmPass) {
                if (newPass !== confirmPass) {
                    toast.error('New password and confirm password must be same.');
                    return;
                }
                formData.set('confirm_password', '');
            }

            const submitBtnPrevState = submitBtn.innerHTML;
            submitBtn.setAttribute('disabled', true);
            submitBtn.innerHTML = spinnerElem;

            const res = await ajaxHandler(formData);

            try {
                if (res) {
                    const { data, success } = res;
                    if (success) {
                        toast.success(data);
                    } else {
                        toast.error(data);
                    }
                }
            } catch (error) {
                toast.error(data);
            } finally {
                // Enable button
                submitBtn.removeAttribute('disabled');
                submitBtn.innerHTML = submitBtnPrevState;
            }
        }

        /**
         * Handle e-mail change.
         */
        btnEmailChange.addEventListener('click', async function (e) {
            const emailInput = document.getElementById('change_email');
            const submitBtnPrevState = btnEmailChange.innerHTML;

            if (emailInput.value === '') {
                return;
            }

            btnEmailChange.setAttribute('disabled', true)
            emailInput.setAttribute('disabled', true);
            btnEmailChange.innerHTML = spinnerElem;

            const formData = new FormData();
            formData.set('email', emailInput.value);
            formData.set('action', 'platform_change_email');

            try {
                const res = await ajaxHandler(formData);
                if (res) {
                    const { data, success } = res;
                    if (success) {
                        toast.success(data)
                        setTimeout(() => { location.reload(true) }, 2000)
                    } else {
                        toast.error(data);
                    }
                }
            } catch (error) {
                toast.error(error);
            } finally {
                btnEmailChange.removeAttribute('disabled');
                emailInput.removeAttribute('disabled');
                btnEmailChange.innerHTML = submitBtnPrevState;
            }

        })

    }

    if (billingSettingForm) {
        billingSettingForm.onsubmit = async (e) => {
            e.preventDefault();
            const formData = new FormData(billingSettingForm);
            const submitBtn = document.querySelector('button[update-billing-info]');

            const submitBtnPrevState = submitBtn.innerHTML;
            submitBtn.setAttribute('disabled', true);
            submitBtn.innerHTML = spinnerElem;

            const res = await ajaxHandler(formData);

            try {
                if (res) {
                    const { data, success } = res;
                    if (success) {
                        toast.success(data)
                    } else {
                        toast.error(data);
                    }
                }
            } catch (error) {
                toast.error(data);
            } finally {
                // Enable button
                submitBtn.removeAttribute('disabled');
                submitBtn.innerHTML = submitBtnPrevState;
            }
        }
    }
})